import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose} from 'redux';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

import { hideMessageModal } from '../../actions/app';

import Loading from '../common/Loading';
import CacheBuster from '../common/CacheBuster';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.messageModal = withReactContent(Swal);
  }

  closeMessageModal = () => {
    const { dispatch } = this.props;
    dispatch(hideMessageModal());
  };

  renderMessageModal = (retryBtn, type, message, errorMessage) => {
    const { t } = this.props;

    this.messageModal.fire({
      type,
      html: message,
      onClose: this.closeMessageModal,
      confirmButtonColor: '#AF6098',
      showConfirmButton: retryBtn,
      confirmButtonText: t('retry'),
      showCancelButton: true,
      cancelButtonText: t('close'),
    })
    .then(() => {
    })
  };

  reloadPage = () => window.location.reload();

  render() {
    const { isLoading, errorMessage, displayError, t } = this.props;

    if (displayError) {
      this.renderMessageModal(
        false,
        'error',
        t([`errors.${errorMessage}`, `errors.genericError`]),
        errorMessage,
      );
    }

    return (
      <div>
        <Loading show={isLoading} />
        <CacheBuster>
          {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return null;
            if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
            }
            return null;
          }}
        </CacheBuster>
      </div>
    );
  }
}

App.propTypes = {
  isLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  isLoading: state.app.loading,
  errorMessage: state.app.errorMessage,
  displayError: state.app.displayError,
});

export default compose(withTranslation('translation'), connect(mapStateToProps))(App);